import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import ClientDetails from './ClientDetails';

export default function BulkArchive({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Archive"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .clients()
          .bulkSetRecordStatus(ids, 'archived')
          .then((r) => r.data)
      }
      renderRow={ClientDetails}>
      {`Are you sure you want to archive ${ids.length} ${pluralize('client', ids.length)}? This will also archive all projects within each client.`}
    </BulkActionModal>
  );
}
